import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useI18nField, useL } from "../locale/LocaleContext";


import { useDeptPageMeta } from "./hooks/useDeptMeta";

const SubDepartments = () => {
  const { deptId } = useParams();

  // SEO TAGS
  useDeptPageMeta(deptId);

  const [department, setDepartment] = useState(null);
  const [subdepartments, setSubdepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const f = useI18nField();
  const t = useL();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const departmentRef = doc(db, "departments", deptId);
        const departmentSnap = await getDoc(departmentRef);

        if (!departmentSnap.exists()) {
          setDepartment(null);
          setSubdepartments([]);
          return;
        }

        setDepartment({ id: departmentSnap.id, ...departmentSnap.data() });

        const subdeptSnapshot = await getDocs(collection(departmentRef, "subdepartments"));
        const subList = subdeptSnapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setSubdepartments(subList);

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [deptId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!department) return <div>Department not found.</div>;
  if (subdepartments.length === 0) return <div>No subdepartments available.</div>;

  const deptName = f(department, "name");
const deptDescription = f(department, "description"); // 👈 NEW

return (
  <div className="py-5 px-4 md:px-8">
    <h1 className="text-2xl font-bold text-center mb-3">{deptName}</h1>

    {/* 👇 editable text area content from AdminConsole */}
    {deptDescription && (
      <p className="max-w-3xl mx-auto text-center text-gray-700 mb-8">
        {deptDescription}
      </p>
    )}

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {subdepartments.map((subdept) => {
        const name = f(subdept, "name");
        return (
          <div key={subdept.id} className="card bg-white rounded-lg p-4 shadow-lg text-center">
            <img
              src={subdept.imageUrl}
              alt={name}
              className="mb-3 w-full object-cover rounded-md"
              style={{ height: "200px" }}
            />
            <h4 className="text-lg font-semibold">{name}</h4>
            <Link
              to={`/departments/${deptId}/subdepartments/${subdept.id}/articles`}
              className="mt-2 text-blue-600 hover:text-blue-800"
            >
              {t({ en: "Learn more", fr: "En savoir plus" })}
            </Link>
          </div>
        );
      })}
    </div>
  </div>
);
};

export default SubDepartments;
